var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15396 15C7.15396 15.6374 6.63751 16.1538 6.00011 16.1538H3.69242C3.05502 16.1538 2.53857 15.6374 2.53857 15C2.53857 14.3626 3.05502 13.8462 3.69242 13.8462H6.00011C6.63758 13.8462 7.15396 14.3626 7.15396 15ZM7.15396 7.61538C7.15396 6.97799 6.63751 6.46154 6.00011 6.46154H3.69242C3.05502 6.46154 2.53857 6.97799 2.53857 7.61538C2.53857 8.25278 3.05502 8.76923 3.69242 8.76923H6.00011C6.63758 8.76923 7.15396 8.25278 7.15396 7.61538ZM7.15396 22.3847C7.15396 21.7472 6.63751 21.2308 6.00011 21.2308H3.69242C3.05502 21.2308 2.53857 21.7472 2.53857 22.3847C2.53857 23.0221 3.05502 23.5385 3.69242 23.5385H6.00011C6.63758 23.5385 7.15396 23.022 7.15396 22.3847ZM27.4617 3.69231V26.3077C27.4617 28.3468 25.8085 30 23.7695 30H7.61563C5.57658 30 3.92333 28.3468 3.92333 26.3077V24.4615H6.00025C7.14534 24.4615 8.07717 23.5296 8.07717 22.3846C8.07717 21.2395 7.14534 20.3076 6.00025 20.3076H3.92319V17.0768H6.00011C7.1452 17.0768 8.07704 16.145 8.07704 14.9999C8.07704 13.8548 7.1452 12.9229 6.00011 12.9229H3.92319V9.69217H6.00011C7.1452 9.69217 8.07704 8.76034 8.07704 7.61525C8.07704 6.47016 7.1452 5.53833 6.00011 5.53833H3.92319V3.69231C3.92319 1.65326 5.57645 0 7.6155 0H23.7693C25.8084 0 27.4617 1.65319 27.4617 3.69231ZM12.8244 10.9449C12.8244 12.9111 14.4186 14.5052 16.3847 14.5052C18.351 14.5052 19.945 12.9111 19.945 10.9449C19.945 8.97876 18.351 7.38455 16.3847 7.38455C14.4186 7.38462 12.8244 8.97876 12.8244 10.9449ZM21.9232 19.6481C21.9232 17.4637 20.1518 15.6922 17.9673 15.6922H14.8026C12.6177 15.6922 10.8463 17.4637 10.8463 19.6481V21.2308H21.9232V19.6481Z",
    fill: "url(#paint0_linear_343_7169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_7169",
    x1: 15.0001,
    y1: 0,
    x2: 15.0001,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744E15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contactsIcon.d4a59657a30f09e936aeeb5dac8b91a9.svg";
export { ForwardRef as ReactComponent };